import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItemPerfilAcessos'
import MenuTree from './menuTreePerfilAcessos'
import { withRouter } from 'react-router-dom';

import { carregarUsuario, alterarSenha } from '../../auth/authActions';
import { getListaMenu } from '../../menuPortal/menuPortalActions';
import LabelAndInput from '../form/labelAndInput';
import Row from '../layout/row';
import Button from '../button/button';
import { Grid } from '@material-ui/core';

class Menu extends Component {

	state = { 
		dadosLogin: {} ,
		cadastroAberto: null,
		integracaoAberto: null,
		ocorrenciaAberto: null,
		metaCombustivelAberto: null,
		laudoAberto: null,
		consultaMotoristaAberto: null,
		comprovacaoAberto: null,
		aprovacaoDespesasAberto: null,
		acessoriosAberto: null,
		valePedagioAberto: null,
		comissaoVariavelAberto: null
	};

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				this.props.getListaMenu();
				clearInterval(idInterval);
			}
		}, 2000);
	}

	render() {

		let selecionado = '';
		if (this.props.location && this.props.location.pathname) {
			selecionado = this.props.location.pathname;
		}
		
		let moduloAcesso = null;
		this.props.listaMenu.forEach(modulo => {
			if (selecionado && modulo.liberado && (modulo.telas || []).filter(tela => tela && tela.liberado && tela.rota && tela.rota == selecionado).length) {
				moduloAcesso = {
					...modulo
				};

				document.title = modulo.nome;
			}
		});

		if (this.props.usuarioCarregado && !this.props.usuarioCarregado.acesso_cliente) {
			return (
				<nav className="mt-2">

					{this.props.usuarioCarregado.primeiro_acesso ? this.modalPrimeiroAcesso() : null}

					<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
						{/* <MenuItem path='/' label='Menu Principal' icon='fas fa-th' 
							onClick={() => {
								window.location.reload();
							}} /> */}
						
						{moduloAcesso &&
						<MenuTree icon={moduloAcesso.icone} label={moduloAcesso.nome}
							display={true} >

							<MenuItem 
								path={'#'} 
								label='Menu Principal'
								title='Menu Principal'
								icon='fas fa-th'
								onClick={() => {
									window.location = '/';
								}} />

							{(moduloAcesso.telas || []).filter(telaAcesso => telaAcesso && telaAcesso.liberado && telaAcesso.rota).map(telaAcesso => (
								<MenuItem 
									key={telaAcesso.id} 
									path={telaAcesso.rota} 
									label={telaAcesso.nome}
									title={telaAcesso.nome}
									icon={telaAcesso.icone}
									active={telaAcesso.rota == selecionado} />
							))}
						</MenuTree>}
					</ul>
				</nav>
			);
		
		} else if (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_cliente) {

			return (
				<nav className="mt-2">

					{this.props.usuarioCarregado.primeiro_acesso ? this.modalPrimeiroAcesso() : null}

					<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
						{this.props.usuarioCarregado && this.props.usuarioCarregado.track ? (
							<MenuItem path='reportsTrack' label='Track 2.0' icon='fas fa-route' active={selecionado == '/'} />
						) : null}
						{this.props.usuarioCarregado && this.props.usuarioCarregado.reports ? (
							<MenuItem path='reports' label='Reports' icon='fas fa-chart-line' active={selecionado == (this.props.usuarioCarregado.track ? '/reports' : '/')} />
						) : null}
					</ul>
				</nav>
			);
		} else {
			return <div />
		}
	}

	getBuscaMenuPortalRota(rota) {
		const menu = (this.props.listaMenu || []).filter(item => item.rota_menu == rota)[0];

		return menu ? menu.acessa || false : false;
	}

	getBuscaMenuPortalLink(link) {

	}

	modalPrimeiroAcesso() {

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
							<h4 class='modal-title'>Primeiro Acesso</h4>
						</div>
						<div class='modal-body' style={{ overflowY: 'scroll' }}>

							<Row alignCenter>
								<LabelAndInput
									name='senha'
									type="password"
									label='Senha *'
									placeholder='Informe a Senha'
									cols='12 12 6 6'
									readOnly={''}
									value={this.state.dadosLogin ? this.state.dadosLogin.senha : ''}
									onChange={data => this.setState({ ...this.state, dadosLogin: { ...this.state.dadosLogin, senha: data.target.value }})}  />
							</Row>
							<Row alignCenter>
								<LabelAndInput
									name='senha_confirmacao'
									type="password"
									label='Confirme sua Senha *'
									placeholder='Informe a Confirmação'
									cols='12 12 6 6'
									readOnly={''}
									value={this.state.dadosLogin ? this.state.dadosLogin.senha_confirmacao : ''}
									onChange={data => this.setState({ ...this.state, dadosLogin: { ...this.state.dadosLogin, senha_confirmacao: data.target.value }})} />
							</Row>
							<Row alignCenter>
								<Grid cols='12 12 6 6'>
									<Button
										text='Salvar nova Senha'
										type={'success'}
										icon={'fa fa-chevron-left'}
										disabled={!this.state.dadosLogin.senha || this.state.dadosLogin.senha != this.state.dadosLogin.senha_confirmacao}
										event={() => this.props.alterarSenha({ ...this.state.dadosLogin, id: this.props.usuarioCarregado.id })} />
								</Grid>
							</Row>

						</div>
					</div>
				</div>
			</div>
        );
    }
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	// listaMenu: state.menuPortal.listaMenu,
	listaMenu: state.menuPerfilAcesso.listaMenu
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario, alterarSenha, getListaMenu }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
